import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface SendCampaignPayload {
  // templateId: string;
  subject: string;
  bodyHtml: string;
  recipients: { email: string; name?: string }[]; // was string[]
  attachments: File[];
  inlineImage?: { cid: string; blob: Blob; filename: string };
}

export interface SendResult {
  recipient: string;
  success: boolean;
  errorMessage?: string;
}

interface ApiRecipientResult {
  email: string;
  status: 'sent' | 'failed' | 'skipped';
  messageId?: string;
  error?: string;
  reason?: string;
}

interface ApiResponse {
  total: number;
  sent: number;
  failed: number;
  results: ApiRecipientResult[];
}

@Injectable({
  providedIn: 'root'
})
export class MailerService {
  private apiUrl = environment.mailerApi.url;
  private apiKey = environment.mailerApi.key;

  constructor(private http: HttpClient) { }

  sendCampaign(payload: SendCampaignPayload): Observable<SendResult> {
    const formData = new FormData();
    formData.append('subject', payload.subject);
    formData.append('bodyHtml', payload.bodyHtml);
    // formData.append('templateId', payload.templateId || '');
    formData.append('recipients', JSON.stringify(payload.recipients));

    payload.attachments.forEach(file => {
      formData.append('attachments', file, file.name);
    });

    if (payload.inlineImage) {
      formData.append('inlineImage', payload.inlineImage.blob, payload.inlineImage.filename);
      formData.append('inlineImageCid', payload.inlineImage.cid);
    }

    return this.http
      .post<ApiResponse>(this.apiUrl, formData, {
        headers: { 'x-api-key': this.apiKey }
      })
      .pipe(
        // The API sends back one result per recipient in a single response.
        // We turn that array into a stream of individual emissions so the
        // component's existing per-recipient subscribe() logic keeps working.
        concatMap(res => from(res.results)),
        map(r => ({
          recipient: r.email,
          success: r.status === 'sent',
          errorMessage: r.status === 'failed' ? r.error : r.status === 'skipped' ? r.reason : undefined
        }))
      );
  }
}